import { service } from '../axios';
export async function getConsDisposalDetail(disposalNumber) {
    return service({
        url: '/cons/disposal/detail',
        method: 'get',
        params: { disposalNumber }
    });
}
export async function saveConsDisposal(data) {
    return service({
        url: '/cons/disposal/save',
        method: 'post',
        data
    });
}
export async function getConsHome(data) {
    return service({
        url: '/cons/home/getHome',
        method: 'post',
        data
    });
}
